import type { UserResponse } from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import { adaptMe } from './adapters'
import type { Me } from './schemas'

// 이 엔드포인트는 CommonResponse 봉투 없이 본문을 바로 낸다.
export const getMe = async (meta?: RequestMeta): Promise<Me> => {
  const body = await httpClient().get<UserResponse>('/users/me', { meta })
  return adaptMe(body)
}
